// extracted by mini-css-extract-plugin
export default {"tagsContainer":"anorXc","alignCenter":"bnorXc","external":"cnorXc","tag":"dnorXc","scroll":"enorXc","column":"fnorXc"};